/* BYC 場面つなぎ（スクロール） sections/byc-scenes.liquid 用。下書き 2026-10-09 ／ 2026-10-17c スマホはスクロールの長さに --bycs-k を掛ける ／ 2026-10-18 動画は表示のあとで読み込む */
(function () {
  var SP = window.matchMedia('(max-width: 749px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pad(n, w) { n = String(n); while (n.length < w) n = '0' + n; return n; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  /* 画面が隠れているとき（別タブ等）は描画の合図が来ないので、タイマーで代わりに進める */
  function tick(f) { return document.hidden ? setTimeout(f, 32) : requestAnimationFrame(f); }

  /* 動画の場面：シーク中は次の目標だけ覚えておき、終わったら最新の位置へ飛ぶ（カクつき防止） */
  function VideoScene(el) {
    this.el = el; this.v = el.querySelector('video'); this.loaded = false; this.want = 0; this.ready = false;
    var self = this, v = this.v;
    v.addEventListener('loadeddata', function () { self.ready = true; el.classList.add('is-ready'); self.seek(); });
    v.addEventListener('seeked', function () { self.seek(); });
  }
  VideoScene.prototype.load = function () {
    if (this.loaded) return; this.loaded = true;
    var src = SP.matches ? this.el.dataset.srcSp : this.el.dataset.src;
    if (!src) return;
    this.v.preload = 'auto'; this.v.src = src; this.v.load();
    /* 2026-10-18 後から読み込んだ動画も、音なしの一瞬再生でコマを描かせる（iPhone対策） */
    this.unlock();
  };
  VideoScene.prototype.unlock = function () {
    /* iPhone は一度再生しないとコマを描かないことがあるので、最初の操作で一瞬だけ再生して止める */
    var v = this.v; if (!this.loaded || this._unlocked) return; this._unlocked = true;
    var p = v.play(); if (p && p.then) p.then(function () { v.pause(); }).catch(function () {});
  };
  VideoScene.prototype.set = function (t) { this.want = t; this.seek(); };
  VideoScene.prototype.seek = function () {
    var v = this.v; if (!this.ready || !v.duration || v.seeking) return;
    var t = this.want * Math.max(0, v.duration - 0.04);
    if (Math.abs(v.currentTime - t) > 0.02) v.currentTime = t;
  };

  /* 連番画像の場面：最初・最後→粗い間隔→細かい間隔の順に読み込み、読めているいちばん近いコマを描く */
  function SeqScene(el) {
    this.el = el; this.c = el.querySelector('canvas'); this.ctx = this.c.getContext('2d');
    this.count = +el.dataset.count || 0; this.seqStart = +el.dataset.start || 0; this.padw = +el.dataset.pad || 4;
    this.imgs = new Array(this.count); this.ok = new Array(this.count); this.loaded = false; this.want = 0; this.drawn = -1; this.ready = false;
  }
  SeqScene.prototype.url = function (i) {
    var pat = SP.matches ? this.el.dataset.seqSp : this.el.dataset.seq;
    return pat.replace('{n}', pad(i + this.seqStart, this.padw));
  };
  SeqScene.prototype.load = function () {
    if (this.loaded || !this.count || !this.el.dataset.seq) return; this.loaded = true;
    var n = this.count, order = [], seen = {}, self = this;
    function add(i) { if (i >= 0 && i < n && !seen[i]) { seen[i] = 1; order.push(i); } }
    add(0); add(n - 1);
    for (var step = 16; step >= 1; step = step >> 1) for (var i = 0; i < n; i += step) add(i);
    var q = 0, active = 0, MAX = 6;
    function next() {
      while (active < MAX && q < order.length) {
        (function (i) {
          active++;
          var im = new Image(); im.decoding = 'async';
          im.onload = function () { self.ok[i] = true; active--; if (!self.ready) { self.ready = true; self.el.classList.add('is-ready'); } self.drawn = -1; self.draw(); next(); };
          im.onerror = function () { active--; next(); };
          im.src = self.url(i); self.imgs[i] = im;
        })(order[q++]);
      }
    }
    next();
  };
  SeqScene.prototype.unlock = function () {};
  SeqScene.prototype.set = function (t) { this.want = t; this.draw(); };
  SeqScene.prototype.draw = function () {
    if (!this.ready) return;
    var n = this.count, want = Math.round(this.want * (n - 1)), idx = -1;
    for (var d = 0; d < n; d++) { if (this.ok[want - d]) { idx = want - d; break; } if (this.ok[want + d]) { idx = want + d; break; } }
    if (idx < 0 || idx === this.drawn) return;
    var c = this.c, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = Math.round(c.clientWidth * dpr), H = Math.round(c.clientHeight * dpr);
    if (c.width !== W || c.height !== H) { c.width = W; c.height = H; }
    var im = this.imgs[idx], iw = im.naturalWidth, ih = im.naturalHeight, s = Math.max(W / iw, H / ih);
    var fx = 0.5, fy = 0.5;
    if (SP.matches) { var f = getComputedStyle(this.el).getPropertyValue('--bycs-focus-sp').trim().split(/\s+/); fx = (parseFloat(f[0]) || 50) / 100; fy = (parseFloat(f[1]) || 50) / 100; }
    var dw = iw * s, dh = ih * s;
    this.ctx.drawImage(im, (W - dw) * fx, (H - dh) * fy, dw, dh);
    this.drawn = idx;
  };

  function init(root) {
    if (!root || root.__bycs) return; root.__bycs = true;
    var track = root.querySelector('.bycs-track');
    var bar = root.querySelector('[data-bar]'), hint = root.querySelector('[data-hint]'), dbg = root.querySelector('[data-dbg]');
    var scenes = [], total = 0;
    root.querySelectorAll('[data-scene]').forEach(function (el) {
      var o = el.dataset.kind === 'sequence' ? new SeqScene(el) : new VideoScene(el);
      o.baseLen = +el.dataset.len || 300; o.baseFade = +el.dataset.fade || 0; o.hold = (+el.dataset.hold || 0) / 100;
      o.caps = el.querySelectorAll('.bycs-ch'); scenes.push(o);
    });
    if (!scenes.length) return;
    /* スクロールの長さの倍率（スマホは CSS の --bycs-k で短くする）。画面幅が変わったら計算し直す */
    function layout() {
      var k = parseFloat(getComputedStyle(root).getPropertyValue('--bycs-k')) || 1, acc = 0;
      scenes.forEach(function (o) { o.start = acc; o.len = o.baseLen * k; o.fade = o.baseFade * k; acc += o.len; });
      total = acc;
    }
    layout();
    if (REDUCE.matches) { scenes.forEach(function (o) { o.el.classList.add('is-vis'); }); return; }

    var shown = 0, target = 0, running = false, started = false;
    function pos() { /* 舞台に貼り付いている間のスクロール量（vh単位） */
      var r = track.getBoundingClientRect();
      /* メニューバーの下から舞台が始まる分（--byc-hh）を差し引き、1pxのスクロールから画面が動くようにする */
      var off = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--byc-hh')) || 0;
      return clamp(-(r.top - off) / (window.innerHeight / 100), 0, total);
    }
    function render(y) {
      for (var i = 0; i < scenes.length; i++) {
        var o = scenes[i];
        /* 次の場面は手前 fade(vh) から読み込み準備・フェードイン */
        /* 2026-10-18 表示速度：動画はページの表示が終わってから読み込む。2つめ以降は、スクロールが始まってから */
        if (started && (i === 0 || (y > 0 && y > o.start - o.fade - 150))) o.load();
        var op;
        if (i === 0) op = 1;
        else if (y >= o.start) op = 1;
        else if (o.fade > 0 && y > o.start - o.fade) op = (y - (o.start - o.fade)) / o.fade;
        else op = 0;
        var nxt = scenes[i + 1];
        if (nxt && y >= nxt.start) op = 0; /* 次が完全に出たら隠す */
        o.el.style.opacity = op;
        o.el.classList.toggle('is-vis', op > 0);
        o.el.style.zIndex = i + 1;
        if (op > 0) {
          var lp = clamp((y - o.start) / o.len, 0, 1);
          var mp = o.hold < 1 ? clamp(lp / (1 - o.hold), 0, 1) : 0;
          /* 最初の場面だけ、動き出しを速くする（少しのスクロールで画面が変わる） */
          if (i === 0) mp = 1 - Math.pow(1 - mp, 2.6);
          o.set(mp);
          var pc = lp * 100;
          for (var k = 0; k < o.caps.length; k++) {
            var c = o.caps[k], on = op >= 1 && pc >= +c.dataset.from && pc <= +c.dataset.to;
            if (i === 0 && pc <= 0 && +c.dataset.from === 0) on = true;
            c.classList.toggle('is-on', on);
          }
        } else {
          for (var k2 = 0; k2 < o.caps.length; k2++) o.caps[k2].classList.remove('is-on');
        }
      }
      if (bar) bar.style.width = (y / total * 100) + '%';
      if (hint) hint.style.opacity = y > 2 ? 0 : 1;
      if (dbg) {
        var cur = 0; for (var j = 0; j < scenes.length; j++) if (y >= scenes[j].start - scenes[j].fade) cur = j;
        dbg.textContent = 'scroll ' + y.toFixed(1) + ' / ' + total + 'vh\nscene ' + (cur + 1) + '/' + scenes.length + (SP.matches ? ' (SP)' : ' (PC)');
      }
    }
    /* なめらかさ：スクロール位置へ少しずつ追いつく */
    function loop() {
      var d = target - shown;
      shown = Math.abs(d) < 0.05 ? target : shown + d * 0.2;
      render(shown);
      if (shown !== target) tick(loop); else running = false;
    }
    function onScroll() { target = pos(); if (!running) { running = true; tick(loop); } }
    function unlockAll() { scenes.forEach(function (o) { o.unlock(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { layout(); scenes.forEach(function (o) { o.drawn = -1; }); onScroll(); });
    window.addEventListener('touchstart', unlockAll, { passive: true, once: true });
    window.addEventListener('pointerdown', unlockAll, { passive: true, once: true });
    target = shown = pos(); render(shown);
    function start() { if (started) return; started = true; target = pos(); render(shown); onScroll(); }
    if (document.readyState === 'complete') setTimeout(start, 400);
    else window.addEventListener('load', function () { setTimeout(start, 400); });
    window.addEventListener('scroll', start, { passive: true, once: true });
    window.addEventListener('touchstart', start, { passive: true, once: true });
  }
  document.querySelectorAll('[data-bycs]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-bycs]')); });
})();
